export default {
  de: {},
  en: {}
}
